import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { FormRow } from '@gravity-ui/components';

import { Button, Icon, Select, Sheet } from '@gravity-ui/uikit';

import { CHOOSE_SECTION, SECTION } from '../../../constants';
import { Xmark } from '@gravity-ui/icons';
import styles from './styles.module.scss';

export const SectionsSelect = ({
	control,
	index,
	sectionsOptions,
	formValues,
	register,
	setSelectedSection,
	setValue,
	errors,
	isMobile,
}: any) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			{isMobile ? (
				<FormRow label={SECTION} className={styles.row} required>
					<Controller
						control={control}
						name={`problems.${index}.parentSectionName`}
						render={({ field: { onChange, onBlur, ref, value }, fieldState: { error } }) => {
							return (
								<Select
									className={styles.row__select}
									size="xl"
									hasClear
									placeholder={CHOOSE_SECTION}
									// key={value || 'default-key'}
									value={value ? [value] : []}
									options={sectionsOptions}
									onUpdate={(value) => {
										const selected = value[0] || null;
										setSelectedSection(selected);
										setValue(`problems.${index}.parentSectionName`, selected);
										// Сбрасываем подраздел при изменении раздела
										setValue(`problems.${index}.subsection.sectionName`, null);
									}}
									validationState={error ? 'invalid' : undefined}
									errorPlacement="inside"
									errorMessage={error?.message}
									onBlur={onBlur}
									ref={ref}
									open={isOpen}
									onOpenChange={setIsOpen}
									renderPopup={({ renderList }) => (
										<Sheet
											visible={isOpen}
											onClose={() => setIsOpen(false)}
											title="Выберите раздел"
											className={styles.sheet}
										>
											<div className={styles.sheet__close}>
												<Button onClick={() => setIsOpen(false)} view="flat">
													<Icon data={Xmark} size={16} />
												</Button>
											</div>

											{renderList?.()}
										</Sheet>
									)}
								/>
							);
						}}
					/>
				</FormRow>
			) : (
				<FormRow label={SECTION} className={styles.row} required>
					<Select
						className={styles.row__select}
						size="xl"
						hasClear
						placeholder={CHOOSE_SECTION}
						// key={formValues.problems?.[index]?.parentSectionName || 'default-key'}
						options={sectionsOptions}
						defaultValue={
							formValues.problems?.[index]?.parentSectionName
								? [formValues.problems?.[index]?.parentSectionName]
								: ''
						}
						{...register(`problems.${index}.parentSectionName`, { required: true })}
						onUpdate={(value) => {
							const selected = value[0] || null;
							setSelectedSection(selected);
							setValue(`problems.${index}.parentSectionName`, selected);
							// Сбрасываем подраздел при изменении раздела
							setValue(`problems.${index}.subsection.sectionName`, null);
						}}
						validationState={errors?.problems?.[index]?.parentSectionName ? 'invalid' : undefined}
						errorPlacement="inside"
						errorMessage={
							errors?.problems?.[index]?.parentSectionName ? 'Обязательно для заполнения' : undefined
						}
					/>
				</FormRow>
			)}
		</>
	);
};
